import {JWspDefProps, JWspTypeInst, WSP, Wsp} from "lib/wsp/wsp";
import {EDrfState, JSrcIdent, SRC} from "lib/wsp/src";
import {IO} from "lib/commons/io/io";


type OWspDrfCreateParams = {
	draftTitle: string;
	alias?: string;
	desc?: string;
}

export namespace WSP_DRF {

	export function getDrfStateLabel(st: EDrfState): any {
		switch (st) {
			//erased, createdDeleted, notOverriden, created, overriden, notComputed
		case "notComputed":
			return "";
		case "notOverriden":
			return "Inchangé";
		case "created":
			return "Nouveau";
		case "createdDeleted":
			return "Nouveau en corbeille";
		case "overriden":
			return "Modifié";
		case "erased":
			return "Supprimé";
		}
		return st;
	}

	export function isDrf(props: JWspDefProps): boolean | undefined {
		if (!props) return undefined;
		return props.drfRefWsp ? true : false;
	}

	export async function createWspDrf(wspRef: Wsp, params: OWspDrfCreateParams, wspType?: JWspTypeInst): Promise<Wsp> {
		(params as any).wspRef = wspRef.code;
		if (wspType == null) {
			if (!wspRef.isLoaded) await wspRef.waitForLoad();
			wspType = wspRef.wspType;
		}
		return WSP.createWsp(wspRef.wspServer, params, wspType);
	}

	export async function srcRevert(wsp: Wsp, uiContext: HTMLElement | null, itemIdents: JSrcIdent[]): Promise<void> {
		if (!wsp.isAvailable) await wsp.waitForAvailable(uiContext);
		const fd = new FormData();
		fd.append("refUris", itemIdents.map(SRC.srcRef).join('\t'));
		return wsp.wspServer.config.drfUrl.fetchVoid(IO.qs("cdaction", "Revert", "param", wsp.code), {method: "POST", body: fd});
	}

	export async function srcCommit(wsp: Wsp, uiContext: HTMLElement | null, itemIdents: JSrcIdent[]): Promise<void> {
		if (!wsp.isAvailable) await wsp.waitForAvailable(uiContext);
		await wsp.wspServer.wspsLive.saveItems(wsp.code, itemIdents);
		const fd = new FormData();
		fd.append("refUris", itemIdents.map(SRC.srcRef).join('\t'));
		return wsp.wspServer.config.drfUrl.fetchVoid(IO.qs("cdaction", "Commit", "param", wsp.code), {method: "POST", body: fd});
	}
}
